//
// Copyright (c) 2021 Astute Global, Inc.
//

import i18next from "i18n/i18n";
import TopicSelectorModule from "modules/shared/topicSelector/topicSelectorModule";
import MarionetteView from "../../marionetteView";
import { PLACEHOLDER_VALUE } from "../../ckEditorConstants";
import { uid } from "ckeditor5";

import "../css/topicLinkSelect.css";

export default class TopicLinkSelect extends MarionetteView {
  constructor(locale, languageId) {
    super(locale);

    this.set("errorText", null);
    this.set("isHidden", false);
    this.set("languageId", languageId);
    this.set("namespace", "topicLink-" + uid());
    this.set("topicId", null);
    this.set("topicLabel", null);

    this.on("change:topicId", (_evt, _name, newValue) => this._onChangeTopicId(newValue));
  }

  createModule() {
    const module = new TopicSelectorModule({
      namespace: this.namespace,
      region: this.region,
    });
    module.on("topic:search:selected", this._onTopicSelect, this);
    return module;
  }

  getClasses() {
    return ["topic-link-select", ...super.getClasses()];
  }

  showModule() {
    this.module.show(this.topicId);
  }

  _onChangeTopicId(newTopicId) {
    if (!newTopicId || newTopicId == PLACEHOLDER_VALUE || !this.module) {
      return;
    }
    this.module.setIntentId(newTopicId);
  }

  _onTopicSelect(model, labels) {
    Promise.all([model.onSyncedPromise(), labels.onSyncedPromise()])
      .then(() => {
        const languageId = this.languageId;
        let topicLabel = "";
        labels.each((label) => {
          if (label.get("languageId") == languageId) {
            topicLabel = label.get("summary");
          }
        });
        if (!topicLabel) {
          this.set("errorText", i18next.t("ckeditor.topicLink.emptyTopic"));
          this.set("topicId", null);
          this.set("topicLabel", null);
        } else {
          this.set("errorText", "");
          this.set("topicId", model.id);
          this.set("topicLabel", topicLabel);
          this.fire("topicLink:select", model, topicLabel);
        }
      })
      .catch((error) => {
        console.error("Failed to fetch topic", error);
        this.set("errorText", i18next.t("ckeditor.topicLink.emptyTopic"));
        this.set("topicId", null);
        this.set("topicLabel", null);
      });
  }
}
